/*
接口请求地址
*/
export const PREFIX = 'travel'

// 城市列表
export const GET_TRAIN_CITY_LIST = `/${PREFIX}/train-toc/queryCityList`

// 根据关键词搜索城市
export const GET_TRAIN_CITY_LIST_BY_KEYWORD =
  `/${PREFIX}/train-toc/queryCityStationNameByKeyword`

//-----------------------------下单---------------------------------------------

//下单 - 支付方式鉴权
export const GET_PAY_TYPE = `/${PREFIX}/train-toc/getPayType`

//下单 - 获取下单基础数据
export const ORDER_BASE_INFO = `/${PREFIX}/train-toc/common/baseMakeOrderInfo`

//下单 - 协议授权触发
export const RE_CHECKED_PROTOCOL = `/${PREFIX}/train-toc/common/rememberCheckedProtocol`

//下单 - 协议授权获取
export const GET_CHECKED_PROTOCOL = `/${PREFIX}/train-toc/common/getCheckedProtocol`

//下单 - 购票
export const MAKE_ORDER = `/${PREFIX}/train-toc/makeOrder`;

//下单 - 购中转票
export const MAKE_UNION_ORDER = `/${PREFIX}/train-toc/makeUnionOrder`;

//下单 - 抢票
export const MAKE_SCRAMBLE_ORDER = `/${PREFIX}/train-toc/makeScrambleTicketOrder`

//下单 - 改签
export const CHANGE_TICKET_ORDER = `/${PREFIX}/train-toc/changeTicket`

//下单 - 支付车票
export const MAKE_PAY = `/${PREFIX}/train-toc/makePay`

//下单 - 支付状态查询
export const GET_PAY_STATUS = `/${PREFIX}/train-toc/getPayStatus`

//订单详情-  订单状态查询
export const ORDER_DETAIL = `/${PREFIX}/train-toc/order/orderDetail`

//订单详情-  获取交易记录
export const DEAL_DETAIL = `/${PREFIX}/train-api/order/feeDetail`

//订单详情-  获取私退私改交易记录
export const OFFLINE_REFUND_FEE_DETAIL = `/${PREFIX}/train-toc/order/offlineRefundFeeDetail`
//订单详情-  私退私改 一键退款
export const OFFLINE_REFUND_MONEY = `/${PREFIX}/train-toc/order/offlineRefundMoney`

//车次列表 - 查询
export const GET_TRAIN_LIST = `/${PREFIX}/train-toc/queryLeftTicket`

//车次列表 - 抢票车次批量查询
export const GET_MULTI_TRAIN_LIST = `/${PREFIX}/train-toc/multiQueryTrainNoList`

// 公告提醒信息
export const SERVICE_NOTICE = `/${PREFIX}/train-toc/serviceNotice`

export const GET_TRAIN_STATION_LIST = `/${PREFIX}/train-toc/queryStationNameByKeyword`

export const GET_TRAIN_TAVEL_LIST = `/${PREFIX}/train-toc/getAvailableTravelList`

export const IDENTITY_INFO_CHECK = `/${PREFIX}/user/identityInfoCheck`

//-----------------------------下单---------------------------------------------

//------------------------------退票--------------------------------------------

//下单 - 退票金额查询
export const QUERY_REFUND_TICKET_COST = `/${PREFIX}/train-toc/queryRefundTicketCost`

//退票原因页-展示退票原因
export const QUERY_REFUND_TICKET_REASON = `/${PREFIX}/train-toc/queryRefundTicketReason`

//退票原因页-确认退票
export const REFUND_TICKET = `/${PREFIX}/train-toc/refundTicket`

//退票详情
export const REFUND_DETAIL = `/${PREFIX}/train-toc/order/getRefundInfo`

//改签详情
export const CHANGE_DETAIL = `/${PREFIX}/train-toc/order/getChangeInfo`

//退票费用明细
export const REFUND_FEE_DETAIL = `/${PREFIX}/train-toc/order/feeDetail`

//查询停靠站信息
export const QUERY_TRAIN_INFO = `/${PREFIX}/train-toc/queryTrainInfo`

export const QUERY_ORDER_LIST = `/${PREFIX}/train-toc/queryOrderList`

export const CANCEL_TRIP_BEFORE = `/${PREFIX}/train-toc/cancelBefore`

export const AUTH = `/${PREFIX}/train-toc/auth`

// 删除订单
export const TRAIN_DELETE_ORDER = `/${PREFIX}/train-toc/delOrder`

//登录
// export const TRAIN_LOGIN = `/${PREFIX}/train-toc/user/login`

//退出登录
export const TRAIN_LOGOUT = `/${PREFIX}/train-toc/user/logout`

//短信核验
export const TRAIN_MESSAGE_CHECK = `/${PREFIX}/train-toc/user/messageVerification`

//证件类型
export const TRAIN_ID_TYPE_LIST = `/${PREFIX}/train-toc/common/idTypeList`

//获取验证码(找回密码)
export const TRAIN_RETRIEVE_PASSWORD = `/${PREFIX}/train-toc/user/retrievePassword`

//密码找回 提交
export const TRAIN_VALIDATE_PASSWORD = `/${PREFIX}/train-toc/user/sendCaptchaResult`

//人脸核验
// export const TRAIN_FACE_CHECK = '/train-toc/user/faceVerification'; // 没有使用 和下面的重复

//查询全车次固定日期余票信息
export const TRAIN_INFO_BY_NO = `/${PREFIX}/train-toc/estimate`

//占座
export const TRAIN_FETCH_ORDER_STATUS = `/${PREFIX}/train-toc/fetchOrderStatus`

//联系客服
export const TRAIN_CUSTOMER_SERVICE = `/${PREFIX}/train-toc/customerService`

export const LOGIN_12306_API = `/${PREFIX}/train-toc/user/login`

export const LOGIN_OUT_12306_API = `/${PREFIX}/train-toc/user/logout`

// 校验用户最近使用账户是否登陆
export const VALIDATE_USER_ACCOUNT = `/${PREFIX}/train-toc/common/existValidateUserAccount`
// 查询用户全部账号信息
export const GET_ALL_USER_ACCOUNT = `/${PREFIX}/train-toc/common/getAllUserAccount`
// 删除12306账户信息
export const DELETE_USER_ACCOUNT = `/${PREFIX}/train-toc/common/deleteUserAccount`
// 注册12306畅行会员
export const REGISTER_CHANGXING_API = `/${PREFIX}/train-toc/common/registerSmoothTravelVip`

//注册12306
export const REGISTER_12306_API = `/${PREFIX}/train-toc/user/register`;

export const FACE_VERIFICATION_12306_API = `/${PREFIX}/train-toc/user/faceVerification`;
// export const FACE_VERIFICATION_12306_API = '/esapp/train/user/identityInfoCheck';

export const MESSAGE_VERIFICATION_12306_API =
  `/${PREFIX}/train-toc/user/messageVerification`

export const USER_CONTACTS = `/${PREFIX}/train-toc/user/contacts`

export const SEND_CONFIRM_INFO = `/${PREFIX}/train-toc/order/sendConfirmInfo`

//保存出行人信息
export const SAVE_CONTACT_INFO = `/${PREFIX}/train-toc/user/add`

//获取出行人信息
export const GET_CONTACT_INFO = `/${PREFIX}/train-toc/user/contacts`


//用户预定校验
export const USER_REVERSE = `/${PREFIX}/train-toc/user/reverse`

// toc接口
// 获取常用联系人列表-拉12306
// 入参 order_type: 1 表示免登录时本地存储的联系人
export const USER_CONTACTS_TOC = `/${PREFIX}/train-toc/user/travelerListV2`
// 指定联系人详情
export const USER_DETAIL_TOC = `/${PREFIX}/train-toc/user/travelerDetail`
// 添加单个联系人
export const USER_ADD_TOC = `/${PREFIX}/train-toc/user/addTraveler`
// 删除指定联系人
export const USER_DEL_TOC = `/${PREFIX}/train-toc/user/delTraveler`
// 修改联系人
export const USER_UPDATE_TOC = `/${PREFIX}/train-toc/user/updateTraveler`
// 联系人状态核验
export const USER_VALIDATE_TOC = `/${PREFIX}/train-toc/user/travelerValidate`
// 获取国家列表
export const GROUP_COUNTRY = `/${PREFIX}/train-toc/common/countryList`
// 合并乘车人
export const TRAVELER_MERGE = `/${PREFIX}/train-toc/user/travelerMerge`


// 获取个人清单信息
export const USER_COLLECTION_TOC = `/${PREFIX}/train-toc/safety/userCollectInfo/index`


// 获取节假日
export const GET_HOLIDAYS = `/${PREFIX}/train-toc/holidays`

// 首页接口
export const GET_HOMEPAGE_DATA = `/${PREFIX}/train-toc/common/home`

// apollo前端专用配置接口
export const GET_APOLLO_CONFIG = `/${PREFIX}/train-toc/getApolloConfig`;

// 领券接口
export const RECIEVE_COUPON = `/${PREFIX}/train-toc/coupon/receive`

// 获取券列表数据
export const GET_COUPON_LIST = `/${PREFIX}/train-toc/coupon/getCouponList`

// 导航时间接口
export const GET_NAV_TIME = `/${PREFIX}/train-toc/common/getNavigation`

// 查询12306本人车票
export const GET_12306_TICKETS = `/${PREFIX}/train-toc/querySelfTicket`

// 首页行程信息接口
export const GET_HOMEPAGE_ORDER_LIST = `/${PREFIX}/train-toc/order/homePageList`

// 加速包明细信息接口
export const GET_ACC_PACK_DETAIL = `/${PREFIX}/train-toc/accelerate/queryUserDetail`

// 加速包助力页面信息接口
export const GET_ACC_PACK_CONTENT = `/${PREFIX}/train-toc/accelerate/share`

// 好友加速接口
export const ACC_PACK_STATUS_UPDATE = `/${PREFIX}/train-toc/accelerate/update`

// 单独购买加速包创建订单接口
export const MAKE_PACKAGE = `/${PREFIX}/train-api/makePackage`

// 加速包支付接口
export const MAKE_EXTRA_PAY = `/${PREFIX}/train-api/makeExtraPay`;

// 抢票详情页加速分享信息
export const GET_SHARE_INFO = `/${PREFIX}/train-api/poster/generatePainter`

// 用户年龄校验
export const GET_VERIFY_AGE = `/${PREFIX}/train-api/passenger/verifyAge`

//下单 - 协议授权获取
export const GET_TRAIN_CHECKED_PROTOCOL = `/${PREFIX}/train-api/common/getCheckedProtocol`

//下单 - 协议授权触发
export const RE_TRAIN_CHECKED_PROTOCOL = `/${PREFIX}/train-api/common/rememberCheckedProtocol`